import { SteamUserDataType } from '@/entities/user'
import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { useUnit } from 'effector-react'
import { useCallback, useState } from 'react'
import { useBackButton } from '@/shared/hooks/useBackButton'
import { Statistics } from '@/shared/ui/dataWrappers/farcanaStatistics'
import { useFormatSteamStats } from '@/shared/hooks/useFormatSteamStats'

export const ProfileOverview = (props: Pick<SteamUserDataType, 'userData'>) => {
  const { userData } = props
  const { classes } = useStyles({})
  const userLang = useUnit($userLanguage)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { basicStats, plusStats } = useFormatSteamStats(userData, userLang)

  const handleBb = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  useBackButton({ onBack: handleBb, forceHide: !isModalOpen })

  return (
    <>
      <div className={classes.rootWrapper}>
        <div className={classes.root}>
          {basicStats.map((stat) => {
            return (
              <Statistics
                key={stat.name}
                name={stat.name}
                value={stat.value!}
                difference={Number(stat.diff)}
              />
            )
          })}
        </div>
        <div
          className={classes.featuresContainer}
          style={{ paddingTop: '12px' }}
        >
          {plusStats.map((stat) => (
            <Statistics
              key={stat.name}
              value={stat.value!}
              name={stat.name}
              isPremiumStat={true}
            />
          ))}
        </div>
      </div>

      {/* <div
        style={{ display: isModalOpen ? 'block' : 'none' }}
        className={classes.modalRoot}
      >
        <h1>{texts.recommendedGames}</h1>
        <div className={classes.gamesWrapper}>
          {favoriteGames?.map((game) => (
            <GamesInfo
              key={game.appid}
              id={game.appid}
              title={game.name}
              img={game.icon_img_url}
            />
          ))}
        </div>
        <ButtonWrapper style={{ display: 'flex', width: '100%', justifyContent: 'center', padding: '16px' }}>
          <AppButton
            className={classes.modalBtn}
            onClick={() => setIsModalOpen(false)}
          >
            {btnTexts.back}
          </AppButton>
        </ButtonWrapper>
      </div> */}
    </>
  )
}
